import { updatesItems } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              实时追踪网红圈最新爆料，每一条都值得吃
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-0">
              {updatesItems.map((item, i) => (
                <div key={item.id} className="relative flex items-start gap-4 pl-12 py-4 group">
                  <div className={`absolute left-3.5 top-5 w-3 h-3 rounded-full border-2 border-background-100 ${i === 0 ? 'bg-primary-500 border-primary-500 animate-pulse' : 'bg-background-300'}`}></div>

                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${tagColorMap[item.tagColor] || tagColorMap.secondary}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors cursor-pointer leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}